import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import MenuItem from './MenuItem.js';

/**
 * Menu Class
 */
export default class Menu extends withBreakpointObserver(Base) {
  static config = {
    name: 'Menu',
    refs: ['menuOpen', 'burger', 'close'],
    components: {
      MenuItem,
    },
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   * @member {boolean} isOpen
   */
  isOpen = false;

  /**
   * Burger menu
   * @returns {Function} @void
   */
  onMenuOpenClick() {
    this.$refs.burger.classList.toggle('hidden');
    this.$refs.close.classList.toggle('hidden');

    if (!this.isOpen) {
      return this.open();
    }
    return this.close();
  }

  /**
   * close
   */
  close() {
    this.isOpen = false;
    document.body.classList.remove('is-menu-open');
    document.body.classList.remove('overflow-hidden');
  }

  /**
   * open
   */
  open() {
    this.isOpen = true;
    document.body.classList.add('is-menu-open');
    document.body.classList.add('overflow-hidden');
  }

  /** @inheritdoc */
  destroyed() {
    this.close();
  }
}
